import React from 'react'

const footerLinksAPI = [
    {
        heading:"Sitemap",
        data:[
            {
                dataname:"Courses",
                link:"/courses"
            },
            {
                dataname:"About Us",
                link:"/aboutus"
            },
            {
                dataname:"Notice",
                link:"/notice"
            },
            {
                dataname:"Blog",
                link:"/blog"
            },
            {
                dataname:"Contact Us",
                link:"/contact"
            },
        ]
    },
    {
        heading:"Legal",
        data:[
            {
                dataname:"Terms and Condiitons"
            },
            {
                dataname:"Privacy policy"
            },
            {
                dataname:"Cookies policy"
            },
            {
                dataname:"Cookies Setting"
            },
            {
                dataname:"Contact Copyright Information"
            },
        ]
    },
    {
        heading:"Contact Information",
        data:[
            {
                dataname:"564, Manon road, F1 456 Caron Town"
            },
            {
                dataname:"01902029595"
            },
            {
                dataname:"Contact@tarbiyahinst.com"
            },
        ]
    },
    {
        heading:"Support",
        data:[
            {
                dataname:"FAQ",                
            },
            {
                dataname:"Contact"
            }
        ]
    },
]

const FooterLinks = () => {
  return (
    <>
    
    </>
  )
}

export {footerLinksAPI}

export default FooterLinks